import React from "react";
import { FlexColumn, FlexRow } from "@/ui/FlexContainer/FlexContainer";
import Typography from "@/ui/Typography/Typography";
import {
  AddCreditCardIcon,
  CheckMarkIcon,
  CreditCardIcon,
  SmallArrowIcon,
  TrashBinIcon,
} from "@/assets/icons";
import ContainerLoader from "@/ui/ContainerLoader/ContainerLoader";
import { useUserDataContext } from "@/store/UserProvider";
import { useTranslation } from "react-i18next";
import { useChoosePaymentOptionsContext } from "./ChoosePaymentOptionsContext";
import {
  getCardLastNumbers,
  getSavedPaymentMethods,
  HIDDEN_CARD_MASK,
} from "./paymentOptionHelpers";
import cls from "./styles.module.scss";

export function PaymentOptionsList() {
  const { t } = useTranslation();
  const { user, paymentOption } = useUserDataContext();
  const {
    isManageMode,
    deletingPaymentMethodId,
    openConfirm,
    requestDeleteCard,
    openAddNewCard,
  } = useChoosePaymentOptionsContext();
  const savedPaymentMethods = getSavedPaymentMethods(user);

  return (
    <FlexColumn gap={12} className={cls.options}>
      {savedPaymentMethods.map((option) => (
        <FlexRow
          key={option.payment_method_id}
          gap={8}
          justifyContent="space-between"
          className={cls.option}
          onClick={() => {
            if (!isManageMode) openConfirm(option.payment_method_id);
          }}
        >
          <FlexRow gap={8} alignItems="flex-start">
            <CreditCardIcon />
            <FlexColumn gap={2}>
              <Typography className={cls.label}>
                {`${t(
                  "paymentOptions.card"
                )} ${HIDDEN_CARD_MASK}${getCardLastNumbers(
                  option.card_metadata?.last4
                )}`}
              </Typography>
              <Typography className={cls.optionText}>
                {user?.subscription_price}₽ {t("paymentOptions.perMonth")}
              </Typography>
            </FlexColumn>
          </FlexRow>

          {isManageMode ? (
            <button
              type="button"
              className={cls.deleteBtn}
              onClick={(e) => {
                e.stopPropagation();
                requestDeleteCard(option.payment_method_id);
              }}
              disabled={deletingPaymentMethodId === option.payment_method_id}
            >
              {deletingPaymentMethodId === option.payment_method_id ? (
                <ContainerLoader />
              ) : (
                <TrashBinIcon />
              )}
            </button>
          ) : (
            <div
              className={`${cls.chekBox} ${
                paymentOption === option.payment_method_id
                  ? cls.activeCheckBox
                  : ""
              } `}
            >
              <CheckMarkIcon />
            </div>
          )}
        </FlexRow>
      ))}

      {!isManageMode && (
        <FlexRow
          gap={8}
          justifyContent="space-between"
          className={cls.option}
          onClick={openAddNewCard}
        >
          <FlexRow gap={8} alignItems="flex-start">
            <AddCreditCardIcon />
            <FlexColumn gap={2}>
              <Typography className={cls.label}>
                {t("paymentOptions.addNewCard")}
              </Typography>
              <Typography className={cls.optionText}>
                {user?.subscription_price}₽ {t("paymentOptions.perMonth")}
              </Typography>
            </FlexColumn>
          </FlexRow>
          <div className={cls.iconBlock}>
            <SmallArrowIcon />
          </div>
        </FlexRow>
      )}
    </FlexColumn>
  );
}
